<template>
<div>
    <div class="devices" v-if="blogdata.length != 0">
      <div class="card-body">
        <h5 class="card-title" style="text-align:center">{{ blogdata.title }}</h5>
        <v-list-item-subtitle  style="text-align:center"><strong>By : </strong>  
          <i>{{ blogdata.created_by }}</i>
        </v-list-item-subtitle>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>
              <i v-html="blogdata.content"></i>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </div>
    </div>
    <div class="devices1" v-if="loadingdata && blogdata.length == 0">
        <v-progress-circular
        :rotate="180"
        :size="100"
        :width="15"
        :value="value"
        color="blue"
        >
        {{ value }}
        </v-progress-circular>
    </div>
    <div class="devices1" v-if="nodata">
        <img src="../assets/404.png" alt="404(Not Found)">
        <h1>404</h1>
        <p>No Data Found</p>
    </div>
</div>
</template>
<script>
import axios from 'axios';

  export default {
    name: 'BlogData',
    components: {
    },
    data: () => ({
        blogdata: [],
        loadingdata: false,
        nodata: false,
        interval: {},
        value: 10
    }),
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    },
    created () {
        this.getblogposts();
    },
    watch: {
      '$route': 'getblogposts'
    },

    methods: {
        getblogposts() {
            let id = `?id=${this.$route.params.id}`
            let config = {
                method : 'get',
                url : `https://kharame-devices.herokuapp.com/getBlogData${id}`,
            };
            this.loadingdata=true;
            axios(config)
            .then((response) => {
                if (response && response.data.message && response.data.status === 'S'){
                    this.blogdata = response.data.message;
                }
                if (this.blogdata) {
                    this.loadingdata = false;
                } else {
                    setTimeout(() => { this.loadingdata = false; }, 2000);
                    setTimeout(() => { this.nodata = true; }, 2000);
                }
                if (this.blogdata.length == 0) {
                  this.nodata = true
                }
            })
        },
    },
  }
</script>
<style scoped>
.devices {
  margin-top:8%;
  margin-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  width:50%;
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6);
}
.devices1 {
  text-align: center;
  margin-top:8%;
  margin-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  width:85%;
}

.v-list-item__content .v-list-item__subtitle{
  color :whitesmoke !important;
  font-size: 14px;
  padding:1%;
}
>>>.ql-align-center {
    text-align : center;
}
>>>.ql-align-right {
    text-align : right;
}
.v-list-item__title, .v-list-item__subtitle{
  white-space: inherit;
}
@media (max-width: 1000px) {
  .devices {
    width: 75%;
    margin-top: 10%;
    margin-bottom: 5%;
  }
  .devices1 {
    margin-top: 10%;
    margin-bottom: 5%;
  }
}
@media (max-width: 550px) {
  .devices {
    width: 85%;
    display: block;
    margin-top: 18%;
    margin-bottom: 12%;
  }
  .devices1 {
    margin-top: 18%;
    margin-bottom: 12%;
  }
}
</style>